var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"call-button",attrs:{"href":'tel:'+_vm.telNumber}},[_c('Button',[_c('i',{staticClass:"fas fa-phone fa-rotate-90"}),_vm._v(" Call ")]),_vm._v(" "+_vm._s(_vm.telNumber)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }